define([
  'backbone',
  'marionette',
  'jquery',
  'underscore',
  'blueimp-file-upload'],
function (Backbone, Marionette, $, _) {
  var FileModel = Backbone.Model.extend({
    defaults: {
      bbcode_url: '',
      short_thumb_url: '',
      short_url: '',
      source: '',
      source_thumb: '',
      type: '',
      filename: '',
      width: 0,
      height: 0
    }
  })

  return Marionette.ItemView.extend({
    template: false,

    model: new FileModel({}),

    options: {
      allow_all_file_attachments: false,
      allowed_file_types: {
        image: ['gif', 'jpeg', 'jpg', 'png'],
        file: ['csv', 'doc', 'docx', 'pdf', 'ppt', 'pptx', 'txt', 'xls', 'xlsx', 'xml', 'zip']
      },
      allowed_file_sizes: {
        image: '5 MB',
        file: '25 MB'
      },

      limit: '50 MB',

      width: 100,
      height: 100,

      labels: {
        error_file_type: 'Is not a valid file type should be one of those: ',
        error_file_size: 'Sorry, we couldn’t upload your file because it\'s too big.',
        error_on_upload: 'Something went wrong, please try again.'
      },

      onUpload: false,
      onUploaded: false,
      onDelete: false
    },

    events: {
      'upload:choose': 'onUploadChoose',
      'upload:validate': 'onUploadValidate',
      'file:valid': 'onFileValid',
      'file:upload:start': 'onFileUploadStart',
      'image:valid': 'onImageValid',
      'image:upload:start': 'onImageUploadStart',
      'image:upload:complete': 'onImageUploadComplete',
      'upload:reset': 'onReset'
    },

    helpers: {
      validateUploadType: function (type, file) {
        const allowedType = this.getOption('allowed_file_types')[type]
        const fileExtensionMatch = file.name.match(/\.[0-9a-zA-Z]+$/)
        let valid = false

        if (this.upload_type === 'image' && type !== 'image') return false
        if (!file && file.name) return true
        if (fileExtensionMatch === null) return false

        const fileExtension = fileExtensionMatch[0].substr(1, fileExtensionMatch[0].length).toLowerCase()

        _.each(allowedType, function (type) {
          if (fileExtension.indexOf(type) > -1) valid = true
        })

        return valid
      },
      validateUploadSize: function (type, file) {
        var sizeAllowed = this.helpers.unhumanizeSize(this.options.allowed_file_sizes[type])
        if (!file.size) return true
        if (file.size <= sizeAllowed) return true
        return false
      },
      validateFileSizeLimit: function (file) {
        var sizeLimit = this.helpers.unhumanizeSize(this.limit || this.options.limit)
        var currentSize = this.total_files_size || 0
        if ((file.size + currentSize <= sizeLimit)) return true
        return false
      },
      bytesToSize: function (bytes, precision) {
        var kilobyte = 1024
        var megabyte = kilobyte * 1024
        var gigabyte = megabyte * 1024
        var terabyte = gigabyte * 1024

        if (bytes >= 0 && bytes < kilobyte) {
          return bytes + ' B'
        } else if (bytes >= kilobyte && bytes < megabyte) {
          return (bytes / kilobyte).toFixed(precision) + ' KB'
        } else if (bytes >= megabyte && bytes < gigabyte) {
          return (bytes / megabyte).toFixed(precision) + ' MB'
        } else if (bytes >= gigabyte && bytes < terabyte) {
          return (bytes / gigabyte).toFixed(precision) + ' GB'
        } else if (bytes >= terabyte) {
          return (bytes / terabyte).toFixed(precision) + ' TB'
        }
        return bytes + ' B'
      },
      unhumanizeSize: function (text) {
        var powers = {
          k: 1,
          m: 2,
          g: 3,
          t: 4
        }
        var regex = /(\d+(?:\.\d+)?)\s?(k|m|g|t)?b?/i
        var res = regex.exec(text)
        return res[1] * Math.pow(1024, powers[res[2].toLowerCase()])
      },
      extractURLParam: function (url, param) {
        var results = new RegExp('[?&]' + param + '=([^&#]*)').exec(url)
        if (results == null) {
          return null
        } else {
          return decodeURIComponent(results[1]) || 0
        }
      }
    },

    // trigger event to choose a file to upload
    onUploadChoose: function (data) {
      this.triggerMethod('upload:reset')
      this.upload_type = data.type
      this.total_files_size = data.files_size
      this.upload_input.trigger('click')
    },

    // upload validation
    onUploadValidate: function () {
      const file = this.upload_input[0].files[0]
      let type
      let valid = true
      let errors = []
      let errorFileType = this.upload_type === 'image' ? this.error_file_type_images : this.error_file_type_files
      const fileExtensionMatch = file.name.match(/\.[0-9a-zA-Z]+$/)
      let fileExtension = fileExtensionMatch === null ? '' : fileExtensionMatch[0].substr(1, fileExtensionMatch[0].length).toLowerCase()

      if (_.contains(this.options.allowed_file_types.image, fileExtension)) {
        type = 'image'
      } else if (_.contains(this.options.allowed_file_types.file, fileExtension) && this.options.allow_all_file_attachments) {
        type = 'file'
      }

      if (type !== undefined) {
        // validate file type
        valid = this.helpers.validateUploadType.call(this, type, file)
        if (!valid) {
          errors.push(errorFileType)
          this.triggerMethod('upload:error', errors)
          return false
        }
        // validate file size
        valid = this.helpers.validateUploadSize.call(this, type, file)

        if (!valid) {
          errors.push(this.options.labels.error_file_size.replace('{allowed_files_size}', this.options.allowed_file_sizes[type]))
          this.triggerMethod('upload:error', errors)
          return false
        }

        if (type === 'file') {
          valid = this.helpers.validateFileSizeLimit.call(this, file)
          if (!valid) {
            errors.push(this.options.labels.error_total_file_size_per_post)
            errors.push(this.options.labels.warning_max_file_size_per_post)
            this.triggerMethod('upload:error', errors)
            return false
          }
        }
        type === 'image' ? this.triggerMethod('image:valid') : this.triggerMethod('file:valid', { file: file, extension: fileExtension })
      } else {
        errors.push(errorFileType)
        this.triggerMethod('upload:error', errors)
      }
    },

    // handlers for images

    onImageValid: function () {
      this.triggerMethod('image:upload:start')
    },

    onImageUploadStart: function () {
      var self = this

      if (_.isFunction(this.options.onUpload)) { this.options.onUpload.call(this) }
      $(self.upload_input)
        .fileupload('send', {
          files: self.upload_input[0].files,
          url: '/attachment/new'
        })
        .done(function (answer) {
          self.triggerMethod('image:upload:complete', answer)
        })
        .fail(function (answer) {
          var errors = []
          if (
            typeof answer.responseJSON !== 'undefined' &&
            typeof answer.responseJSON.errors !== 'undefined'
          ) {
            if (_.isArray(answer.responseJSON.errors)) {
              errors = answer.responseJSON.errors
            } else {
              errors.push(answer.responseJSON.errors)
            }
          } else if (
            typeof answer.responseText !== 'undefined' &&
            answer.responseText.trim() !== ''
          ) {
            errors.push(answer.responseText)
          } else {
            errors.push(self.options.labels.error_on_upload)
          }
          self.triggerMethod('upload:error', errors)
        })
    },

    onImageUploadComplete: function (data) {
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data)
        } catch (e) {
          data = false
        }
      }
      if (data) {
        this.upload_input.val('')
        this.model.clear().set(data)
        this.triggerMethod('image:upload:end', data)

        // handle callback
        if (_.isFunction(this.options.onUploaded)) {
          this.options.onUploaded.call(this, data)
        }
      }
    },

    // handlers for all other files

    onFileValid: function (data) {
      this.triggerMethod('file:upload:start', data)
    },

    onFileUploadStart: function (data) {
      var self = this

      self.getSignedUrl(data.file.name, data.file.type)
        .then(function (response) {
          var amzTaggingParam = self.helpers.extractURLParam(response.url, 'x-amz-tagging')
          self.uploadFileToS3(response.url, amzTaggingParam, data)
            .then(function () {
              var result = {
                source: response.download_url,
                type: data.extension,
                bbcode_url: response.download_url,
                file_original_name: data.file.name,
                file_size: data.file.size,
                file_uuid: response.uuid
              }
              self.upload_input.val('')
              self.model.clear().set(result)
              self.triggerMethod('file:upload:end', result)
            })
            .fail(function (err) {
              self.onFileUploadError(err)
            })
        })
        .fail(function (err) {
          self.onGetSignedUrlError(err)
        })
    },

    getSignedUrl: function (filename, contentType) {
      var signedUrl = '/attachment/signedUrl?filename=' + filename + '&content_type=' + contentType
      return $.ajax(signedUrl)
    },

    onGetSignedUrlError: function () {
      var errors = []
      errors.push(this.options.labels.error_on_upload)
      this.triggerMethod('upload:error', errors)
    },

    uploadFileToS3: function (url, amzTaggingParam, data) {
      return $.ajax(url, {
        method: 'PUT',
        data: data.file,
        contentType: data.file.type + '; charset=utf-8',
        headers: {
          'x-amz-tagging': amzTaggingParam
        },
        processData: false
      })
    },

    onFileUploadError: function (err) {
      var errors = []
      errors.push(this.options.labels.error_on_upload, err)
      this.triggerMethod('upload:error', errors)
    },

    initialize: function () {
      // compose error messages
      this.error_file_type_images = this.options.labels.error_file_type.replace('{allowed_files_type}', this.options.allowed_file_types.image.join(', '))
      this.error_file_type_files = this.options.labels.error_file_type.replace('{allowed_files_type}', this.options.allowed_file_types.image.concat(this.options.allowed_file_types.file).join(', '))
    },

    setFromInput: function () {
      var _id = _.uniqueId('uploader-')
      var elem =
          '<input type="file" class="is-hidden" id="' +
          _id +
          '" name="image" />'
      var el = $(this.$el).parent().append(elem).find('#' + _id)

      this.id = _id
      this.upload_input = el
    },

    bindInput: function () {
      var self = this
      $(self.upload_input[0]).fileupload({
        autoUpload: false,
        replaceFileInput: false,
        paramName: self.upload_input.attr('name'),
        url: '/attachment/new'
      })
    },

    onRender: function () {
      var self = this
      this.setFromInput()
      this.bindInput()
      this.upload_input.on('change', function () {
        self.triggerMethod('upload:validate')
      })
    },

    onReset: function () {
      this.upload_input.val('')
      this.model.clear().set(this.model.defaults)
      this.id = _.uniqueId('uploader-')

      if (_.isFunction(this.options.onDelete)) { this.options.onDelete.call(this) }

      return false
    }
  })
})
